var map = {
	"./ChevronRight.svg": [
		67013,
		7013
	],
	"./GreaterThanArrow.svg": [
		54394,
		4394
	],
	"./LessThanArrowDisabled.svg": [
		84417,
		4417
	],
	"./UpSideTriangle.svg": [
		30274,
		274
	],
	"./account.svg": [
		27213,
		9594
	],
	"./add.svg": [
		11969,
		1969
	],
	"./additional_tasks.svg": [
		24936,
		4936
	],
	"./address_book.svg": [
		49648,
		9648
	],
	"./alert-circle.svg": [
		33831,
		3831
	],
	"./alert.svg": [
		38810,
		8810
	],
	"./alert_management.svg": [
		98408,
		8408
	],
	"./archive.svg": [
		11786,
		1786
	],
	"./autoplay-start.svg": [
		33204,
		3204
	],
	"./autoplay-stop.svg": [
		34832,
		4832
	],
	"./autoplay-to-start.svg": [
		64776,
		4776
	],
	"./autoplay-to-stop.svg": [
		21356,
		1356
	],
	"./bar_graph.svg": [
		74658,
		4658
	],
	"./binoculars.svg": [
		7866,
		7866
	],
	"./book.svg": [
		23423,
		3423
	],
	"./bookmark.svg": [
		93600,
		3600
	],
	"./briefcase.svg": [
		5556,
		5556
	],
	"./browser.svg": [
		6824,
		6824
	],
	"./browser_load.svg": [
		27411,
		7411
	],
	"./calculator.svg": [
		27616,
		7616
	],
	"./calendar-disabled.svg": [
		83131,
		3131
	],
	"./calendar-error.svg": [
		96639,
		6639
	],
	"./calendar.svg": [
		85746,
		5746
	],
	"./changeorg.svg": [
		49346,
		9346
	],
	"./chat1.svg": [
		16223,
		6223
	],
	"./check-circle.svg": [
		75653,
		5653
	],
	"./check.svg": [
		24728,
		4728
	],
	"./check_circle.svg": [
		33795,
		3795
	],
	"./checkbox-circle.svg": [
		50920,
		920
	],
	"./checkmark-dark-mode.svg": [
		63232,
		3232
	],
	"./checkmark.svg": [
		7475,
		7475
	],
	"./chevron-right.svg": [
		27432,
		7432
	],
	"./chevron_down.svg": [
		71536,
		1536
	],
	"./chevron_down2.svg": [
		84898,
		4898
	],
	"./chevron_right.svg": [
		65402,
		5402
	],
	"./chevron_up.svg": [
		54883,
		4883
	],
	"./chevron_up2.svg": [
		7707,
		7707
	],
	"./circle_close.svg": [
		53661,
		3661
	],
	"./circlecheck.svg": [
		98892,
		8892
	],
	"./clock-disabled.svg": [
		18043,
		8043
	],
	"./clock-error.svg": [
		92575,
		2575
	],
	"./clock.svg": [
		33842,
		3842
	],
	"./close.svg": [
		58372,
		5991
	],
	"./column_spacing.svg": [
		82876,
		2876
	],
	"./columns.svg": [
		93177,
		3177
	],
	"./component.svg": [
		73597,
		3597
	],
	"./context_address.svg": [
		18372,
		8372
	],
	"./context_select.svg": [
		86684,
		6684
	],
	"./copy.svg": [
		1911,
		1911
	],
	"./csv.svg": [
		76888,
		6888
	],
	"./cut.svg": [
		68656,
		8656
	],
	"./dashboard.svg": [
		28020,
		8020
	],
	"./doc.svg": [
		5898,
		5898
	],
	"./doc_output_notify.svg": [
		24970,
		4970
	],
	"./dollar_sign.svg": [
		28362,
		8362
	],
	"./downSideTriangle.svg": [
		45337,
		5337
	],
	"./download.svg": [
		62672,
		2672
	],
	"./dropdown-arrow.svg": [
		68163,
		8163
	],
	"./edit-prompt-arrow.svg": [
		28359,
		8359
	],
	"./edit.svg": [
		61655,
		4036
	],
	"./edit_context.svg": [
		42856,
		2856
	],
	"./editprompt_1.svg": [
		88174,
		8174
	],
	"./editprompt_2.svg": [
		36525,
		6525
	],
	"./empty_box.svg": [
		44773,
		4773
	],
	"./enquiries.svg": [
		79803,
		9803
	],
	"./error-fatal.svg": [
		58639,
		8639
	],
	"./error.svg": [
		19042,
		9042
	],
	"./error_report.svg": [
		92095,
		2095
	],
	"./excel_document.svg": [
		65207,
		5207
	],
	"./eye.svg": [
		47343,
		7343
	],
	"./facebook.svg": [
		20628,
		628
	],
	"./filter.svg": [
		19630,
		9630
	],
	"./filter_ascend.svg": [
		50495,
		495
	],
	"./filter_clear.svg": [
		21928,
		1928
	],
	"./filter_descend.svg": [
		96541,
		6541
	],
	"./flag.svg": [
		72270,
		2270
	],
	"./folder.svg": [
		43556,
		3556
	],
	"./format_text.svg": [
		47585,
		7585
	],
	"./function_loader.svg": [
		53006,
		3006
	],
	"./google.svg": [
		1997,
		1997
	],
	"./grid_view.svg": [
		21408,
		1408
	],
	"./hamburger_menu.svg": [
		70349,
		349
	],
	"./help.svg": [
		8593,
		8593
	],
	"./help_circle.svg": [
		91576,
		1576
	],
	"./hide.svg": [
		25408,
		5408
	],
	"./history.svg": [
		84472,
		4472
	],
	"./home.svg": [
		49829,
		9829
	],
	"./html_doc.svg": [
		18592,
		8592
	],
	"./ibs_enterprise.svg": [
		85294,
		5294
	],
	"./information.svg": [
		78122,
		8122
	],
	"./invert-arrows.svg": [
		54003,
		4003
	],
	"./invoice.svg": [
		72225,
		2225
	],
	"./item_serial.svg": [
		73156,
		3156
	],
	"./kebab_menu1.svg": [
		8748,
		8748
	],
	"./kebab_menu2.svg": [
		87775,
		7775
	],
	"./kebab_vertical-dark.svg": [
		83973,
		3973
	],
	"./kebab_vertical.svg": [
		56952,
		6952
	],
	"./keyboard.svg": [
		63767,
		3767
	],
	"./left_arrow.svg": [
		65237,
		5237
	],
	"./left_arrow_circle.svg": [
		12428,
		2428
	],
	"./less_than_arrow.svg": [
		15021,
		5021
	],
	"./link.svg": [
		52400,
		2400
	],
	"./linkedin.svg": [
		20366,
		366
	],
	"./location_pin.svg": [
		56757,
		6757
	],
	"./mail.svg": [
		24789,
		4789
	],
	"./menu.svg": [
		85397,
		5397
	],
	"./menu_option.svg": [
		64731,
		4731
	],
	"./menuopt_next.svg": [
		70732,
		732
	],
	"./menuoption_transaction.svg": [
		52963,
		2963
	],
	"./notification.svg": [
		20621,
		621
	],
	"./open.svg": [
		42088,
		2088
	],
	"./open_book.svg": [
		36872,
		6872
	],
	"./open_folder.svg": [
		8487,
		8487
	],
	"./package.svg": [
		45264,
		5264
	],
	"./panel_messages.svg": [
		34681,
		4681
	],
	"./paperclip-1.svg": [
		88794,
		8794
	],
	"./paperclip.svg": [
		81876,
		1876
	],
	"./paste.svg": [
		40489,
		489
	],
	"./pdf.svg": [
		58378,
		8378
	],
	"./personal_settings.svg": [
		15920,
		5920
	],
	"./play-classic-start.svg": [
		78166,
		8166
	],
	"./play-classic-stop.svg": [
		7798,
		7798
	],
	"./print_view.svg": [
		54339,
		4339
	],
	"./printer.svg": [
		55996,
		5996
	],
	"./printer_view.svg": [
		78884,
		8884
	],
	"./profile.svg": [
		86271,
		6271
	],
	"./project.svg": [
		58687,
		8687
	],
	"./prompt-arrow.svg": [
		78150,
		8150
	],
	"./qlink.svg": [
		43381,
		3381
	],
	"./query.svg": [
		73252,
		3252
	],
	"./quicklinks.svg": [
		74104,
		4104
	],
	"./refresh.svg": [
		65065,
		5065
	],
	"./refresh2.svg": [
		52633,
		2633
	],
	"./reorder.svg": [
		75897,
		5897
	],
	"./requisite.svg": [
		36179,
		6179
	],
	"./reset-arrow.svg": [
		88665,
		8665
	],
	"./right_arrow.svg": [
		2212,
		2212
	],
	"./right_arrow_circle.svg": [
		54879,
		4879
	],
	"./save.svg": [
		19223,
		9223
	],
	"./search.svg": [
		46748,
		6748
	],
	"./server_view.svg": [
		12191,
		2191
	],
	"./settiings.svg": [
		22042,
		2042
	],
	"./shipping.svg": [
		82574,
		2574
	],
	"./shopping_cart.svg": [
		62929,
		2929
	],
	"./signout.svg": [
		77321,
		7321
	],
	"./sitemap.svg": [
		89353,
		9353
	],
	"./skype.svg": [
		80866,
		866
	],
	"./sliders.svg": [
		38334,
		8334
	],
	"./star.svg": [
		34528,
		4528
	],
	"./supply_chain.svg": [
		47703,
		7703
	],
	"./system_management.svg": [
		67691,
		7691
	],
	"./table.svg": [
		53668,
		3668
	],
	"./table_refresh.svg": [
		1840,
		1840
	],
	"./tasks.svg": [
		59182,
		9182
	],
	"./text-error.svg": [
		43480,
		3480
	],
	"./tool.svg": [
		95606,
		5606
	],
	"./tool2.svg": [
		85272,
		5272
	],
	"./trash.svg": [
		7174,
		7174
	],
	"./upload.svg": [
		42955,
		2955
	],
	"./url.svg": [
		23211,
		3211
	],
	"./user_group.svg": [
		10581,
		581
	],
	"./view.svg": [
		13931,
		3931
	],
	"./warehouse.svg": [
		60353,
		353
	],
	"./warning.svg": [
		53356,
		3356
	],
	"./wikipedia.svg": [
		30829,
		829
	],
	"./word_document.svg": [
		47484,
		7484
	],
	"./workc.svg": [
		28870,
		8870
	],
	"./x-circle.svg": [
		35061,
		5061
	],
	"./xml_doc.svg": [
		64972,
		4972
	],
	"./zip.svg": [
		18685,
		8685
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28871;
module.exports = webpackAsyncContext;